import _get from 'lodash/get'
import _pick from 'lodash/pick'
import _omit from 'lodash/omit'
import _set from 'lodash/set'
import _has from 'lodash/has'
import Bluebird from 'bluebird'
import request from '../../request'
import { CONTENT_IMPRESSION_SELECTED } from '../../../gui/components/merchandising/CampaignTargeting/constants'
import { createAuthorization } from '../../auth'

const removeTitles = (campaign) => {
  const targeting = _get(campaign, 'campaignTargeting')
  let newCampaign = campaign

  targeting.forEach((target, i) => {
    if (
      _get(target, 'targetMethod') === 'has-watched' ||
      _get(target, 'targetMethod') === 'following' ||
      _get(target, 'targetMethod') === CONTENT_IMPRESSION_SELECTED ||
      _get(target, 'targetMethod') === 'rainbow-category'
    ) {
      const params = _get(target, 'targetParams')
      const newParams = params.map((param) => _omit(param, 'title'))
      newCampaign = _set(campaign, ['campaignTargeting', i, 'targetParams'], newParams)
    }
  })
  return newCampaign
}

/**
 * Get merchandising campaigns from brooklyn
 */
export async function getMerchandisingCampaigns ({
  auth,
  server,
  page,
  perPage,
  slug,
  placement,
  isActive,
  dateRange,
  placementLanguage,
}) {
  const query = {}
  if (placementLanguage) query.placementLanguage = placementLanguage
  if (page) query.p = page
  if (perPage) query.pp = perPage
  if (slug) query['filter[slug]'] = slug
  if (placement) query['filter[placement]'] = placement
  if (dateRange) query['filter[dateRange]'] = dateRange
  if (isActive) query['filter[isActive]'] = 'active'

  const res = await request
    .get(`${server}/admin/merchandising/campaigns`)
    .query(query)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')

  return _get(res, 'body', {})
}

export async function createMerchandisingCampaign ({ auth, server, campaign }) {
  const campaignWithoutTitles = removeTitles(campaign)
  const res = await request
    .post(`${server}/admin/merchandising/campaign`)
    .send(campaignWithoutTitles)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')

  return _get(res, 'body', {})
}

export async function updateMerchandisingCampaign ({ auth, server, campaign, campaignId }) {
  const campaignWithoutTitles = removeTitles(campaign)
  const res = await request
    .put(`${server}/admin/merchandising/campaign/${campaignId}`)
    .send(campaignWithoutTitles)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')

  return _get(res, 'body', {})
}

export async function deleteMerchandisingCampaign ({ auth, server, campaignId }) {
  const res = await request
    .delete(`${server}/admin/merchandising/campaign/${campaignId}`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')

  return _get(res, 'body', {})
}

export async function createCampaignContent ({ auth, server, campaignContent, language }) {
  const body = _pick(campaignContent.toJS(), ['campaignId', 'contentType', 'contentId', 'label'])
  body.language = language
  body.contentId = parseInt(body.contentId, 10)
  const res = await request
    .post(`${server}/admin/merchandising/campaign-content`)
    .send(body)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')

  return _get(res, 'body', {})
}

export async function updateCampaignContent ({ auth, server, campaignContent, id, language }) {
  const body = _pick(campaignContent.toJS(), [
    'campaignId',
    'contentType',
    'contentId',
    'label',
    'language',
  ])
  body.language = language
  body.contentId = parseInt(body.contentId, 10)
  body.label = body.label === '' ? null : body.label
  const res = await request
    .put(`${server}/admin/merchandising/campaign-content/${id}`)
    .send(body)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')

  return _get(res, 'body', {})
}

export async function hasPreviewMedia ({ auth, server, id }) {
  if (!id) {
    return {}
  }

  const res = await request
    .get(`${server}/node/${id}`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')

  return _has(res, 'body.preview.nid')
}

export async function getOnboard ({ auth, server }) {
  // eslint-disable-next-line camelcase
  const [v1_3] = await Bluebird.all([
    request
      .get(`${server}/v5/user/onboard-choices`)
      .set('authorization', createAuthorization(auth))
      .set('accept', 'application/json'),
  ])

  return {
    1.3: _get(v1_3, 'body', {}),
  }
}

export async function createMerchandisingCampaignWithContent ({ auth, server, campaign }) {
  const campaignWithoutTitles = removeTitles(campaign)
  const res = await request
    .post(`${server}/admin/merchandising/campaign-with-content`)
    .send(campaignWithoutTitles)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')

  return _get(res, 'body', {})
}
